import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Badge,
  Button,
  UncontrolledTooltip
} from 'reactstrap';
import TeremberlesUrlap from './TeremberlesUrlap';
import TeremberlesFizetesUrlap from './TeremberlesFizetesUrlap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../commons/dataemptystate';
import NetworkEmptyState from '../../commons/networkemptystate';
import Loader from '../../commons/loader';
import Services from './Services';
import { PaginationTotal } from '../../commons/controls';
import Lib from '../../commons/lib';
import Moment from 'moment';
import momentLocalizer from "react-widgets-moment";
import TimeFormatter from '../../commons/TimeFormatter';
// import '../../App.css';
// momentLocalizer(Moment);

class TeremberlesContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // DATA
      baseJson: [],
      currentId: undefined,
      torlesId: undefined,
      // MODAL UTILS
      modalForm: false,
      modalView: false,
      modalModositas: false,
      modalFizetes: false,
      modalDelete: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
      // FORM VALUES

      allapotok: [],
      allapotOptions: [],
      filterOptions: {},

    };
  }

  // componentDidUpdate(prevProps) {
  //   // Typical usage (don't forget to compare props):
  //   if (this.props.active !== prevProps.active) {
  //     if (this.props.active)
  //       this.listTeremberles()
  //   }
  // }

  componentDidMount() {
    this.listTeremberles()
  }

  dateToTimezone = (date) => {
    if (!date || date === '')
      return null;

      return TimeFormatter.formatIso(date);
  }

  timezoneToDate = (date) => {
    if (!date || date === '')
      return null;

      return TimeFormatter.formatDateTimeWithoutSeconds(date);
  }

  listTeremberles = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listTeremberles((err, res) => {
        if (!err) {
          let filters = {};
          let options = res[0].allapot.map((e) => {
            filters[e.name] = e.caption;
  
            return <option key={e.name} value={e.name}>{e.caption}</option>;
          });

          this.setState({
            tableStatus: res[0].list.length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0].list,
            allapotok: res[0].allapot,
            allapotOptions: options,
            filterOptions: filters,
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  toggleFormModal = () => {
    this.setState((prevState) => ({
      modalForm: !prevState.modalForm
    }));
  }

  toggleViewModal = () => {
    this.setState((prevState) => ({
      modalView: !prevState.modalView
    }));
  }

  toggleFizetesModal = () => {
    this.setState((prevState) => ({
      modalFizetes: !prevState.modalFizetes
    }));
  }

  toggleDeleteModal = () => {
    this.setState((prevState) => ({
      modalDelete: !prevState.modalDelete
    }));
  }

  handleNewClick = () => {
    this.setState((prevState) => ({ modalForm: !prevState.modalForm, formType: 'INSERT' }));
  }

  handleViewClick = (id) => {
    this.setState((prevState) => ({ modalView: !prevState.modalView, currentId: id, formType: 'VIEW' }));
  }

  handleEditClick = (id) => {
    this.setState((prevState) => ({ modalForm: !prevState.modalForm, currentId:id, formType: 'MODIFY' }));
    }

    handleDeleteClick = (id) => {
      this.setState((prevState) => ({ modalDelete: !prevState.modalDelete, currentId:id, formType: 'DELETE' }));
    }

    handleFizetesClick = (id) => {
      this.setState((prevState) => ({ modalFizetes: !prevState.modalFizetes, currentId: id }));
    }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        {this.props.globals.hasRole(['TEREMBERLES_TEREMBERLES']) && (
          <React.Fragment>
              <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'view'} onClick={() => this.handleViewClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'view'} delay={50}>
                {'Megtekintés'}
              </UncontrolledTooltip>
          </React.Fragment>
        )}
        {(((this.props.globals.hasRole(['TEREMBERLES_TEREMBERLES'], true) && 'ROGZITETT' === row.allapot) ||
          this.props.globals.hasRoleSpec(['TEREMBERLES_FIZ_KARB']))) && 'TOROLT' !== row.allapot && (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
              {'Módosítás'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
        {this.props.globals.hasRole(['TEREMBERLES_TEREMBERLES'], true) && 'TOROLT' !== row.allapot && (
          <React.Fragment>
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'torles'} delay={50}>
              {'Törlés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
        {this.props.globals.hasRoleSpec(['TEREMBERLES_FIZ_KARB']) && !row.fizetesidopont && 'TOROLT' !== row.allapot && (
          <React.Fragment>
            <Button className="icon-wallet table-action-icon" id={'action-view-' + cell + 'fizetes'} onClick={() => this.handleFizetesClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'fizetes'} delay={50}>
              {'Fizetés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  idopontFormatter = (cell) => {
    return this.timezoneToDate(cell)
  }

  intervallumFormatter = (cell, row) => {
    return this.timezoneToDate(row.kezdeteidopont) + ' - ' + this.timezoneToDate(row.vegeidopont)
  }

  allapotFormatter = (cell) => {
    let allapot = this.state.allapotok.find(x => x.name === cell);
    return allapot ? <span className={'badge badge-' + allapot.color}>{allapot.caption}</span> : 'N/A';
  }

  renderTable = () => {
    const options = {
      sizePerPage: 10,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 }
      ],
    };

    const allapotOptions = {
      ROGZITETT: 'Rögzített',
      FIZETETT: 'Fizetett',
      TOROLT: 'Törölt',
    }

    const columns = [
      {
        dataField: 'helyszin',
        text: 'Helyszín',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'terem',
        text: 'Terem',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'idopont',
        text: 'Időpont (kezdete - vége)',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
          textAlign: 'center'
        },
        formatter: this.intervallumFormatter,
        filterValue: this.intervallumFormatter,
        sort: true,
        sortFunc: (a, b, order, dataField, rowA, rowB) => {
          let aTime = new Date(rowA.kezdeteidopont).getTime();
          let bTime = new Date(rowB.kezdeteidopont).getTime();
          let result = aTime > bTime ? 1 : -1;
          return result * (order === 'asc' ? 1 : -1);
        },
        headerStyle: { width: '260px' }
      },
      {
        dataField: 'nev',
        text: 'Program megnevezése',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'fizetesidopont',
        text: 'Fizetés dátuma',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
          textAlign: 'center'
        },
        formatter: this.idopontFormatter,
        filterValue: this.idopontFormatter,
        sort: true,
        headerStyle: { width: '150px' }
      },
      {
        dataField: 'allapot',
        text: 'Állapot',
        filter: selectFilter({
          options: this.state.filterOptions,
          placeholder: 'Összes',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
          textAlign: 'center'
        },
        formatter: this.allapotFormatter,
        sort: true,
        headerStyle: { width: '150px' }
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        hidden: !this.props.globals.hasRole(['TEREMBERLES_TEREMBERLES']),
        formatter: this.tableIconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          wrapperClasses="table-responsive"
          classes="table-scroll"
          headerClasses="table-th"
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

render() {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12">
        {this.props.globals.hasRole(['TEREMBERLES_TEREMBERLES'], true) && (
          <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
            {'Új terembérlés'}
          </Button>
        )}
        </div>
        <div className="col-md-12">
          {{
            LOAD: (<Loader />),
            DATA: (<DataEmptyState
              hasImage
              subtitle="Vigyél fel új tételt!"
            />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => { this.listTeremberles() }}
            />),
            TABL: (this.renderTable())
          }[this.state.tableStatus]}
        </div>
      </div>
      <TeremberlesUrlap
        globals={this.props.globals}
        id={this.state.currentId}
        formType={this.state.formType}
        toggleViewModal={this.toggleViewModal}
        toggleFormModal={this.toggleFormModal}
        modalView={this.state.modalView}
        modalForm={this.state.modalForm}
        modalDelete={this.state.modalDelete}
        toggleDeleteModal={this.toggleDeleteModal}
        hasFizKarbRole={this.props.globals.hasRoleSpec(['TEREMBERLES_FIZ_KARB'])}
        listTeremberles={this.listTeremberles}
        />

      <TeremberlesFizetesUrlap
        globals={this.props.globals}
        id={this.state.currentId}
        toggleFizetesModal={this.toggleFizetesModal}
        modalFizetes={this.state.modalFizetes}
        hasFizKarbRole={this.props.globals.hasRoleSpec(['TEREMBERLES_FIZ_KARB'])}
        list={this.listTeremberles} />
    </React.Fragment>
  );
}
}

TeremberlesContent.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default TeremberlesContent;
